import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Button, Modal, Checkbox } from "antd";
import { downloadByTypes } from "../../../common/request";
import ResponseCode from "../../../common/response-code";
import { FileExcelOutlined, FileZipOutlined } from "@ant-design/icons";
import router from "../../../routers/router";

const ManualAllocationModal = forwardRef(({ batchInfo, locationList }, ref) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedFileList, setSelectedFileList] = useState([]);

  useEffect(() => {
    if (modalVisible) setSelectedFileList([]);
  }, [modalVisible]);

  const downloadMenuList = [
    { label: "考生安排表", value: "EXAMINEES_TABLE", format: "Excel" },
    { label: "考场统计表", value: "ROOM_STATISTICS", format: "Zip" },
    { label: "考生浏览表", value: "EXAMINEES_STATISTICS", format: "Zip" },
    { label: "座次表", value: "SEAT_TABLE", format: "Zip" },
    { label: "桌贴", value: "TABLE_STICKERS", format: "Zip" },
    { label: "门贴", value: "DOOR_STICKERS", format: "Zip" },
  ];

  useImperativeHandle(ref, () => {
    return { showModal };
  });

  const showModal = () => {
    setModalVisible(true);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const indeterminate =
    selectedFileList.length > 0 &&
    selectedFileList.length < downloadMenuList.length;

  const checkedAll = selectedFileList.length === downloadMenuList.length;

  const changeAll = (e) => {
    setSelectedFileList(
      e.target.checked ? downloadMenuList.map((item) => item.value) : []
    );
  };

  const selectItem = (e) => {
    const { checked, value } = e.target;
    if (checked) {
      setSelectedFileList((pre) => [...pre, value]);
    } else {
      const index = selectedFileList.findIndex((item) => item === value);
      selectedFileList.splice(index, 1);
      setSelectedFileList([...selectedFileList]);
    }
  };

  const onOk = async () => {
    setLoading(true);
    try {
      const params = {
        examId: batchInfo.examId,
        batchId: batchInfo.batchId,
        locationIds: locationList.map((item) => item.locationId),
        downloadTypes: selectedFileList,
      };
      const res = await downloadByTypes(params);
      if (res.code === ResponseCode.success) {
        const failList = [];
        Object.keys(res.data).forEach((key) => {
          const msg = res.data[key];
          if (msg !== "SUCCESS") {
            const name = downloadMenuList.find(
              (item) => item.value === key
            ).label;
            failList.push(`${name}下载失败:${msg.replace("FAILED:", "")}`);
          }
        });
        if (failList.length === 0) {
          Modal.confirm({
            type: "success",
            title: "操作成功",
            content: "下载任务已添加，是否跳转到下载中心查看",
            onOk: () => {
              const siteId = sessionStorage.getItem("siteId");
              router.navigate(`/${siteId}/exam/download-center`);
            },
          });
        } else {
          Modal.error({
            title: "下载失败",
            content: (
              <>
                {failList.map((item) => (
                  <div>{item}</div>
                ))}
              </>
            ),
          });
        }
      } else {
        Modal.error({ title: "错误", content: res.msg });
      }
    } catch (err) {
      console.error(err);
      Modal.error({ title: "错误", content: "网络错误，下载考场安排数据失败" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div ref={ref}>
      <Modal
        width={800}
        title={"下载文件"}
        open={modalVisible}
        onOk={onOk}
        onCancel={hideModal}
        footer={[
          <Button key={"cancel"} onClick={hideModal}>
            取消
          </Button>,
          <Button
            type={"primary"}
            key={"confirm"}
            onClick={onOk}
            loading={loading}
            disabled={selectedFileList.length === 0}
          >
            开始下载
          </Button>,
        ]}
      >
        <div className="my-3">
          <Checkbox
            indeterminate={indeterminate}
            checked={checkedAll}
            onChange={changeAll}
          >
            全选
          </Checkbox>
        </div>
        <div style={containerStyle}>
          {downloadMenuList.map((file) => (
            <div style={cardStyle} key={file.label}>
              <Checkbox
                value={file.value}
                checked={selectedFileList.includes(file.value)}
                onChange={selectItem}
              >
                <div className="d-flex ml-3">
                  {file.format === "Excel" && (
                    <FileExcelOutlined style={{ fontSize: "20px" }} />
                  )}
                  {file.format === "Zip" && (
                    <FileZipOutlined style={{ fontSize: "20px" }} />
                  )}
                  <div className="ml-3">
                    <div>{file.label}</div>
                    <div className="mt-1" style={{ color: "#666" }}>
                      {file.format}格式
                    </div>
                  </div>
                </div>
              </Checkbox>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
});

const containerStyle = {
  display: "grid",
  gap: "20px",
  gridTemplateColumns: "1fr 1fr",
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "14px",
  padding: "20px",
};

export default ManualAllocationModal;
